import { render, staticRenderFns } from "./HeadBar.vue?vue&type=template&id=6aed6414&"
import script from "./HeadBar.vue?vue&type=script&lang=js&"
export * from "./HeadBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aed6414')) {
      api.createRecord('6aed6414', component.options)
    } else {
      api.reload('6aed6414', component.options)
    }
    module.hot.accept("./HeadBar.vue?vue&type=template&id=6aed6414&", function () {
      api.rerender('6aed6414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/HeadBar.vue"
export default component.exports